import React, { useEffect } from "react";
import "./Contactus.scss";

import { FaXTwitter, FaInstagram, FaFacebookF } from "react-icons/fa6";
import { IoPhonePortraitOutline, IoMailOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import ROUTES from "../../../constants/routes";
import { updateOpenSupport } from "../../../redux/features/user-slice";
import { useDispatch } from "react-redux";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";

const Contactus = ({ outside, isModel }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentViewPort, isReady } = useViewPortDetector();

  const INSTA_TAG =
    process.env.REACT_APP_INSTA_TAG || process.env.REACT_APP_SOCIAL_TAG;
  const INSTA_LINK = process.env.REACT_APP_INSTA_LINK;
  const TWITTER_TAG =
    process.env.REACT_APP_TWITTER_TAG || process.env.REACT_APP_SOCIAL_TAG;
  const TWITTER_LINK = process.env.REACT_APP_TWITTER_LINK;
  const FACEBOOK_TAG =
    process.env.REACT_APP_FACEBOOK_TAG || process.env.REACT_APP_SOCIAL_TAG;
  const FACEBOOK_LINK = process.env.REACT_APP_FACEBOOK_LINK;

  const SUPPORT_MAIL = process.env.REACT_APP_SUPPORT_MAIL;
  const SUPPORT_PHONE = process.env.REACT_APP_SUPPORT_PHONE;

  const handleCloseContactModel = () => {
    dispatch(updateOpenSupport({ open_support: false }));
  };

  useEffect(() => {
    if (isReady && !isModel && currentViewPort === "desktop" && !outside) {
      navigate(`${ROUTES.help.path}?query=contact`);
    }
  }, [isModel, isReady, currentViewPort]);
  return (
    <>
      {isModel && (
        <div className="support-model-navbar">
          <div
            className="back"
            onClick={() => {
              handleCloseContactModel();
            }}
          >
            <IoIosArrowBack />
          </div>
          <p>Contact Us</p>
        </div>
      )}
      <div className={`contact-us-page ${outside ? "outside" : ""}`}>
        {outside && (
          <div className="contact-us-navbar">
            <div
              className="back"
              onClick={() => {
                navigate(ROUTES.login.path);
              }}
            >
              <IoIosArrowBack />
            </div>
            <p>Contact Us</p>
          </div>
        )}
        <div className="container-wrapper contact-us-container">
          <p className="heading">
            You can get in touch with us through below platforms. Our Team will
            reach out to you as soon as it would be possible.
          </p>

          <div className="contents-wrapper">
            <p className="title">Customer Support</p>

            <div className="contents">
              {/* <Link to={`tel:${SUPPORT_PHONE}`} className="item">
              <div className="left">
                <IoPhonePortraitOutline />
              </div>
              <div className="right">
                <span>Phone Number</span>
                <p>{SUPPORT_PHONE}</p>
              </div>
            </Link> */}
              <Link to={`mailto:${SUPPORT_MAIL}`} className="item">
                <div className="left">
                  <IoMailOutline />
                </div>
                <div className="right">
                  <span>Email Address</span>
                  <p>{SUPPORT_MAIL}</p>
                </div>
              </Link>
            </div>
          </div>

          {/* <div className="contents-wrapper">
          <p className="title">Social Media</p>

          <div className="contents">
            <Link to={INSTA_LINK} target="_blank" className="item ">
              <div className="left insta">
                <FaInstagram />
              </div>
              <div className="right">
                <span>Instagram</span>
                <p>{INSTA_TAG}</p>
              </div>
            </Link>
            <Link to={TWITTER_LINK} target="_blank" className="item ">
              <div className="left twitter">
                <FaXTwitter />
              </div>
              <div className="right">
                <span>Twitter</span>
                <p>{TWITTER_TAG}</p>
              </div>
            </Link>
            <Link to={FACEBOOK_LINK} target="_blank" className="item ">
              <div className="left facebook">
                <FaFacebookF />
              </div>
              <div className="right">
                <span>Facebook</span>
                <p>{FACEBOOK_TAG}</p>
              </div>
            </Link>
          </div>
        </div> */}
        </div>
      </div>
    </>
  );
};

export default Contactus;
